import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { Button } from "../components/ui/button";
import PolicyContent from "../components/PolicyContent";

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen grid-bg text-slate-100">
      <nav className="glass sticky top-0 z-50 border-b border-slate-800 px-5 sm:px-6 py-4 flex items-center justify-between">
        <button
          data-testid="policy-brand-home"
          onClick={() => navigate("/")}
          className="flex items-center gap-2 font-display font-extrabold text-lg"
        >
          <img src="/swotkit-logo.png" alt="SwotKit" className="h-9 w-9 rounded-lg bg-white p-0.5" />
          SwotKit
        </button>
        <Button data-testid="policy-back-button" size="sm" variant="ghost" onClick={() => navigate(-1)} className="text-slate-200 hover:bg-slate-800">
          <ArrowLeft className="h-4 w-4 mr-1" /> Back
        </Button>
      </nav>

      <div className="max-w-3xl mx-auto px-5 sm:px-6 py-10 sm:py-14">
        <div className="flex items-center gap-2 text-teal-300">
          <ShieldCheck className="h-5 w-5" />
          <span className="text-xs uppercase tracking-wide font-semibold">Legal</span>
        </div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold mt-2">Privacy Policy &amp; Terms of Use</h1>
        <div className="mt-6">
          <PolicyContent />
        </div>
      </div>
    </div>
  );
}
